"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "buttonStyles", {
  enumerable: true,
  get: function get() {
    return _ButtonModule.default;
  }
});
Object.defineProperty(exports, "PoweredByVitusPay", {
  enumerable: true,
  get: function get() {
    return _PoweredByVitusPay.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "Loader", {
  enumerable: true,
  get: function get() {
    return _Loader.default;
  }
});
Object.defineProperty(exports, "PrivacyDataDisplay", {
  enumerable: true,
  get: function get() {
    return _PrivacyDataDisplay.default;
  }
});
Object.defineProperty(exports, "Typeahead", {
  enumerable: true,
  get: function get() {
    return _Typeahead.default;
  }
});
Object.defineProperty(exports, "mapToTypeaheadOptions", {
  enumerable: true,
  get: function get() {
    return _Typeahead.mapToTypeaheadOptions;
  }
});
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function get() {
    return _Spinner.default;
  }
});
Object.defineProperty(exports, "Layout", {
  enumerable: true,
  get: function get() {
    return _Layout.default;
  }
});
Object.defineProperty(exports, "PracticeBanner", {
  enumerable: true,
  get: function get() {
    return _PracticeBanner.default;
  }
});
Object.defineProperty(exports, "InvoiceDetails", {
  enumerable: true,
  get: function get() {
    return _InvoiceDetails.default;
  }
});
Object.defineProperty(exports, "PaymentMethodButtons", {
  enumerable: true,
  get: function get() {
    return _PaymentMethodButtons.default;
  }
});
Object.defineProperty(exports, "ReceiptButtons", {
  enumerable: true,
  get: function get() {
    return _ReceiptButtons.default;
  }
});
Object.defineProperty(exports, "SuccessDisplay", {
  enumerable: true,
  get: function get() {
    return _SuccessDisplay.default;
  }
});
Object.defineProperty(exports, "SuccessHeader", {
  enumerable: true,
  get: function get() {
    return _SuccessHeader.default;
  }
});
Object.defineProperty(exports, "CustomHR", {
  enumerable: true,
  get: function get() {
    return _CustomHR.default;
  }
});
Object.defineProperty(exports, "FlavorText", {
  enumerable: true,
  get: function get() {
    return _FlavorText.default;
  }
});
Object.defineProperty(exports, "PaymentFailed", {
  enumerable: true,
  get: function get() {
    return _PaymentFailed.default;
  }
});
Object.defineProperty(exports, "OrderComplete", {
  enumerable: true,
  get: function get() {
    return _OrderComplete.default;
  }
});
Object.defineProperty(exports, "MakePaymentButton", {
  enumerable: true,
  get: function get() {
    return _MakePaymentButton.default;
  }
});
Object.defineProperty(exports, "ReceiptFailed", {
  enumerable: true,
  get: function get() {
    return _ReceiptFailed.default;
  }
});
Object.defineProperty(exports, "ErrorDisplay", {
  enumerable: true,
  get: function get() {
    return _ErrorDisplay.default;
  }
});
Object.defineProperty(exports, "SpreedlyExpressForm", {
  enumerable: true,
  get: function get() {
    return _SpreedlyExpressForm.default;
  }
});
Object.defineProperty(exports, "SplititHostedForm", {
  enumerable: true,
  get: function get() {
    return _SplititHostedForm.default;
  }
});
Object.defineProperty(exports, "PayFabricHostedForm", {
  enumerable: true,
  get: function get() {
    return _PayFabricHostedForm.default;
  }
});
Object.defineProperty(exports, "ContactPracticeMessage", {
  enumerable: true,
  get: function get() {
    return _ContactPracticeMessage.default;
  }
});
Object.defineProperty(exports, "PayFabricPaymentsSDK", {
  enumerable: true,
  get: function get() {
    return _PayFabricPaymentsSDK.default;
  }
});
Object.defineProperty(exports, "emailIsValidFormat", {
  enumerable: true,
  get: function get() {
    return _emailValidation.emailIsValidFormat;
  }
});
Object.defineProperty(exports, "phoneIsValidFormat", {
  enumerable: true,
  get: function get() {
    return _phoneValidation.phoneIsValidFormat;
  }
});
Object.defineProperty(exports, "createGAEventHandler", {
  enumerable: true,
  get: function get() {
    return _googleAnalyticsHelpers.createGAEventHandler;
  }
});
Object.defineProperty(exports, "splitStringByIndex", {
  enumerable: true,
  get: function get() {
    return _splitStringByIndex.splitStringByIndex;
  }
});
Object.defineProperty(exports, "replaceWithX", {
  enumerable: true,
  get: function get() {
    return _replaceStringWithXs.replaceWithX;
  }
});
Object.defineProperty(exports, "localLogger", {
  enumerable: true,
  get: function get() {
    return _loggers.localLogger;
  }
});
Object.defineProperty(exports, "spacedLogger", {
  enumerable: true,
  get: function get() {
    return _loggers.spacedLogger;
  }
});
Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return _useDebounce.default;
  }
});
Object.defineProperty(exports, "centsToUSD", {
  enumerable: true,
  get: function get() {
    return _money.centsToUSD;
  }
});
Object.defineProperty(exports, "dollarToUSD", {
  enumerable: true,
  get: function get() {
    return _money.dollarToUSD;
  }
});
Object.defineProperty(exports, "getDiscountPrice", {
  enumerable: true,
  get: function get() {
    return _money.getDiscountPrice;
  }
});
Object.defineProperty(exports, "convertCreditCardToPaymentMethod", {
  enumerable: true,
  get: function get() {
    return _creditCard.convertCreditCardToPaymentMethod;
  }
});
Object.defineProperty(exports, "getRedirectUrls", {
  enumerable: true,
  get: function get() {
    return _splititFunctions.getRedirectUrls;
  }
});
Object.defineProperty(exports, "formTypes", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.formTypes;
  }
});
Object.defineProperty(exports, "paymentTypes", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.paymentTypes;
  }
});
Object.defineProperty(exports, "receiptTypes", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.receiptTypes;
  }
});
Object.defineProperty(exports, "getPaymentButtonDescription", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.getPaymentButtonDescription;
  }
});
Object.defineProperty(exports, "getPaymentButtonHeading", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.getPaymentButtonHeading;
  }
});
Object.defineProperty(exports, "getMonthlyAmount", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.getMonthlyAmount;
  }
});
Object.defineProperty(exports, "getPaymentButtonObjects", {
  enumerable: true,
  get: function get() {
    return _paymentHelpers.getPaymentButtonObjects;
  }
});

var _ButtonModule = _interopRequireDefault(require("./global/components/Button.module.css"));

var _PoweredByVitusPay = _interopRequireDefault(require("./global/components/PoweredByVitusPay"));

var _Button = _interopRequireDefault(require("./global/components/Button"));

var _Loader = _interopRequireDefault(require("./global/components/Loader"));

var _PrivacyDataDisplay = _interopRequireDefault(require("./global/components/PrivacyDataDisplay"));

var _Typeahead = _interopRequireWildcard(require("./global/components/Typeahead"));

var _Spinner = _interopRequireDefault(require("./global/components/Spinner"));

var _Layout = _interopRequireDefault(require("./payment/Layout"));

var _PracticeBanner = _interopRequireDefault(require("./payment/PracticeBanner"));

var _InvoiceDetails = _interopRequireDefault(require("./payment/InvoiceDetails"));

var _PaymentMethodButtons = _interopRequireDefault(require("./payment/PaymentMethodButtons"));

var _ReceiptButtons = _interopRequireDefault(require("./payment/ReceiptButtons"));

var _SuccessDisplay = _interopRequireDefault(require("./payment/SuccessDisplay"));

var _SuccessHeader = _interopRequireDefault(require("./payment/SuccessHeader"));

var _CustomHR = _interopRequireDefault(require("./payment/CustomHR"));

var _FlavorText = _interopRequireDefault(require("./payment/FlavorText"));

var _PaymentFailed = _interopRequireDefault(require("./payment/PaymentFailed"));

var _OrderComplete = _interopRequireDefault(require("./payment/OrderComplete"));

var _MakePaymentButton = _interopRequireDefault(require("./payment/MakePaymentButton"));

var _ReceiptFailed = _interopRequireDefault(require("./payment/ReceiptFailed"));

var _ErrorDisplay = _interopRequireDefault(require("./payment/ErrorDisplay"));

var _SpreedlyExpressForm = _interopRequireDefault(require("./payment/SpreedlyExpressForm"));

var _SplititHostedForm = _interopRequireDefault(require("./payment/SplititHostedForm"));

var _PayFabricHostedForm = _interopRequireDefault(require("./payment/PayFabricHostedForm"));

var _ContactPracticeMessage = _interopRequireDefault(require("./payment/ContactPracticeMessage"));

var _PayFabricPaymentsSDK = _interopRequireDefault(require("./payment/PayFabricPaymentsSDK"));

var _emailValidation = require("./global/utils/emailValidation");

var _phoneValidation = require("./global/utils/phoneValidation");

var _googleAnalyticsHelpers = require("./global/utils/googleAnalyticsHelpers");

var _splitStringByIndex = require("./global/utils/splitStringByIndex");

var _replaceStringWithXs = require("./global/utils/replaceStringWithXs");

var _loggers = require("./global/utils/loggers");

var _useDebounce = _interopRequireDefault(require("./global/utils/useDebounce"));

var _money = require("./global/utils/money");

var _creditCard = require("./global/utils/creditCard");

var _splititFunctions = require("./payment/splititFunctions");

var _paymentHelpers = require("./payment/paymentHelpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }